import { TRIGGER_NODE_SETTINGS } from "./TriggerNodes";

export function TriggerNodeSettings(props) {
  const { pipelineType, ...restProps } = props;

  return TRIGGER_NODE_SETTINGS[pipelineType]({ ...restProps });
}
